import { useNamespaceCopy } from '@/i18n/ns';
import storefrontCopy from '@/i18n/ns/storefront';

/** A quiet entry beside the existing preview, before the person sends a design request. */
export function StorefrontDesignWelcome() {
  const copy = useNamespaceCopy(storefrontCopy);
  return (
    <div className="ws-welcome" data-testid="sf-design-welcome">
      <h1>{copy.assistantTitle}</h1>
      <p>{copy.designReviewBody}</p>
    </div>
  );
}
